import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import ScheduleTableHead from './ScheduleTableHead';
import ScheduleTableBody from './ScheduleTableBody';

import LoadMask from '../../../../../../components/LoadMask';
import AlertMessage from '../../../../../../components/AlertMessage';

import Pagination from '../../../../../../components/Pagination';

// Thunks + Selectors
import { getScheduleList } from '../../../../../../redux/scheduling';
import { getScheduleListUI } from '../../../../../../redux/selectors';

// CSS
import './styles.css';

class ScheduleTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      headers: [
        { title: 'ID', alignment: 'left', highlighted: true },
        { title: 'CD', alignment: 'left', highlighted: false },
        { title: 'Operação', alignment: 'left', highlighted: false },
        {
          title: 'Data',
          alignment: 'left',
          style: 'date',
          highlighted: false,
        },
        { title: 'Doca', alignment: 'center', highlighted: false },
        { title: 'Cliente', alignment: 'left', highlighted: false },
        { title: 'NFs', alignment: 'center', highlighted: false },
        { title: 'Volumes', alignment: 'right', highlighted: false },
        {
          title: 'Peso (kg)',
          alignment: 'right',
          style: 'decimal',
          highlighted: false,
        },
        {
          title: 'Valor (R$)',
          alignment: 'right',
          style: 'currency',
          highlighted: false,
        },
        { title: 'Motorista', alignment: 'left', highlighted: false },
        { title: 'Veículo', alignment: 'center', highlighted: false },
        { title: 'Status', alignment: 'center', highlighted: false },
      ],
      paginationOptions: [
        {
          value: 10,
          label: '10',
        },
        {
          value: 25,
          label: '25',
        },
        {
          value: 50,
          label: '50',
        },
        {
          value: 100,
          label: '100',
        },
      ],
      currentPage: 1,
      currentPageLimit: 10,
    };
  }

  componentDidMount() {
    this.props.dispatch(getScheduleList(this.state.currentPage, this.state.currentPageLimit));
  }

  _onRetry = () => {
    this.props.dispatch(getScheduleList(this.state.currentPage, this.state.currentPageLimit));
  }

  _changePage = (newPage) => {
    this.props.dispatch(getScheduleList(newPage, this.state.currentPageLimit));

    this.setState({
      currentPage: newPage,
    });
  }

  _changePageLimit = (newPageLimit) => {
    this.props.dispatch(getScheduleList(this.state.currentPage, newPageLimit));

    this.setState({
      currentPageLimit: newPageLimit,
    });
  }

  render() {
    const { ui, scheduleList } = this.props;

    return (
      <div>
        {
          ui.isFetching &&
          !ui.error &&
          <LoadMask
            text="Carregando..."
          />
        }

        {
          !ui.isFetching &&
          ui.error &&
          <AlertMessage
            className="ScheduleTable__error-message"
            error
            box
            message={ui.error}
            onRetry={this.props.onRetry}
            actionText="Tente novamente"
          />
        }

        {
          !ui.error &&
          <div>
            <div className="ScheduleTable__container">
              <table className="ScheduleTable">
                <ScheduleTableHead
                  headers={this.state.headers}
                />

                <ScheduleTableBody
                  data={scheduleList}
                  headers={this.state.headers}
                  onTableItemClick={(data) => { this.props.onTableItemClick(data); }}
                />
              </table>
            </div>

            <Pagination
              options={this.state.paginationOptions}
              currentPage={this.state.currentPage}
              pageLimit={this.state.currentPageLimit}
              totalItems={scheduleList.totalItems}
              onChangePage={this._changePage}
              onPageLimitChange={this._changePageLimit}
            />
          </div>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    scheduleList: state.scheduling.scheduleList.data,
    ui: getScheduleListUI(state),
  };
}

export default connect(mapStateToProps)(ScheduleTable);
